import React from "react";

function AgencyCalendarDashFilters({
  label,
  onNavigate,
  activeFilter,
  eventFiltersHandler,
}) {
  const navigate = action => {
    onNavigate(action);
  };

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button type="button" onClick={() => navigate("PREV")}>
          Prev
        </button>
        <button type="button" onClick={() => navigate("TODAY")}>
          Today
        </button>
        <button type="button" onClick={() => navigate("NEXT")}>
          Next
        </button>
      </span>
      <span className="rbc-toolbar-label">{label}</span>
      <div className="rbc-btn-group filters">
        <button
          type="button"
          className={activeFilter === "ownEvents" ? `active-filter` : ``}
          onClick={() => eventFiltersHandler("ownEvents")}
        >
          Assigned to Me
        </button>
        <button
          type="button"
          className={activeFilter === "bookedEvents" ? `active-filter` : ``}
          onClick={() => eventFiltersHandler("bookedEvents")}
        >
          All
        </button>
      </div>
    </div>
  );
}

export default AgencyCalendarDashFilters;
